export abstract class Detector {
  abstract detect(): string | undefined;
}
